import React, { useMemo } from 'react';
import { useFocusIdx } from '@bay-email/editor';
import { TextField } from '../../../components/Form';
import { t } from '@bay-email/core';
import { UseFieldConfig } from 'react-final-form';

export function BorderWidth({
	label,
	secondary,
	config,
}: {
	label?: string;
	secondary?: boolean;
	config?: UseFieldConfig<any>;
}) {
	const { focusIdx } = useFocusIdx();

	return useMemo(() => {
		return (
			<TextField
				quickchange
				label={label || t('Thickness')}
				secondaryLabel={secondary}
				name={`${focusIdx}.attributes.border-width`}
				config={config}
			/>
		);
	}, [focusIdx, secondary]);
}
